import { Vocabulary } from "../../Utils/Vocabulary";
import {
  Box,
  Divider,
  Grid,
  Paper,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import style from "../../Styles/vehicleInfo.module.css";
import { ChangeEvent, useContext, useEffect, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { urlEnum } from "../../Utils/urlEnum";
import { updateData } from "../../Services/updateData";
import { getData } from "../../Services/getData";
import { CacheContext } from "../../Context/cacheContext";
import { NumericFormatCustom } from "../../Utils/NumericFormatComponent";
import { getActiveLocations } from "../../Utils/utils";

const iniatialState = {
  trimester1: { targetVolum: "", comisionCA: "", comisionProfit: "" },
  trimester2: { targetVolum: "", comisionCA: "", comisionProfit: "" },
  trimester3: { targetVolum: "", comisionCA: "", comisionProfit: "" },
  trimester4: { targetVolum: "", comisionCA: "", comisionProfit: "" },
  ComisionVanzare: "",
  IDCostComisionAchizitie: "",
  IDCostComisionLogistica: "",
  ComisionTargetVolum: "",
  ComisionTargetCA: "",
  ComisionTargetProfit: "",
  minimumCommission: "",
  taxForLeasingBonus: "",
  generalTax: "",
  socialInsurance: "",
  healthInsurance: "",
  incomeTax: "",
  minimalSellingTarget: "",
  marketingCommission: "",
  managerCommission: "",
  managerCommissionForUnachievedTarget: "",
  purchaseTypeCommissions: {} as Record<string, string>,
};

export default function SalaryCOnfiguration() {
  const [state, setState] = useState(iniatialState);
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const cacheContext = useContext(CacheContext);
  const cacheData = cacheContext.cache;
  const activeLocations = getActiveLocations(cacheData?.locations) || [];
  const purchaseTypes: { id: number; nume: string }[] = cacheData?.purchaseType || [];

  /**
   * Get salary settings when location tab changes
   */
  useEffect(() => {
    if (activeLocations && activeLocations.length > 0) {
      getSettings();
    }
  }, [selectedTabIndex, cacheData?.locations]);

  const convertFromDecimalToPercentage = (percentage: string) => {
    return (parseFloat(percentage) * 100).toString();
  };

  const convertFromPercentageToDecimal = (percentage: string) => {
    return (parseFloat(percentage) / 100).toString();
  };

  /**
   * Get settings for selected location
   */
  async function getSettings() {
    if (!activeLocations || activeLocations.length === 0) return;
    const selectedLocation = activeLocations[selectedTabIndex];
    if (!selectedLocation) return;
    const url = `${urlEnum.locationSettings}/${selectedLocation.id}`;
    const settings = await getData(url);
    // if (
    //   settings.data?.data?.trimester1 &&
    //   settings.data?.data?.trimester2 &&
    //   settings.data?.data?.trimester3 &&
    //   settings.data?.data?.trimester4
    // )
    const data = settings.data?.data;
    const rawCommissions: Record<string, number> = data?.purchaseTypeCommissions || {};
    const purchaseTypeCommissions: Record<string, string> = Object.fromEntries(
      Object.entries(rawCommissions).map(([id, rate]) => [
        id,
        convertFromDecimalToPercentage(String(rate)),
      ]),
    );

    setState({
      ...iniatialState,
      ...data,
      // Convert marketingCommission from decimal to percentage for display
      marketingCommission: data?.marketingCommission
        ? convertFromDecimalToPercentage(data.marketingCommission)
        : "",
      // Convert managerCommission from decimal to percentage for display
      managerCommission: data?.managerCommission
        ? convertFromDecimalToPercentage(data.managerCommission)
        : "",
      // Convert managerCommissionForUnachievedTarget from decimal to percentage for display
      managerCommissionForUnachievedTarget:
        data?.managerCommissionForUnachievedTarget
          ? convertFromDecimalToPercentage(
              data.managerCommissionForUnachievedTarget,
            )
          : "",
      purchaseTypeCommissions,
    });
  }

  const handleChangePurchaseTypeCommission = (
    id: number,
    value: string,
  ) => {
    setState((prev) => ({
      ...prev,
      purchaseTypeCommissions: {
        ...prev.purchaseTypeCommissions,
        [String(id)]: value,
      },
    }));
  };

  /**
   * update state
   * @param event
   * @param trimester
   */
  const handleChangeTextFields = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    trimester = null,
  ) => {
    if (trimester) {
      const newObj = Object.assign(state)[trimester];
      newObj[event.target.name] = event.target.value;
      setState({ ...state, [trimester]: newObj });
    } else setState({ ...state, [event.target.name]: event.target.value });
  };

  /**
   *
   * @param trimester
   * @param number
   * @returns
   */
  const renderTrimester = (trimester: any, number: number) => {
    return (
      <fieldset
        style={{
          border: "1px solid #e0e0e0",
          borderRadius: "12px",
          marginTop: 20,
          padding: "20px",
        }}
      >
        <legend>
          <Typography
            style={{
              fontSize: "0.9rem",
              fontWeight: 600,
              padding: "0 10px",
              color: "#FF6633",
            }}
          >
            {Vocabulary.Trimester + " " + number}
          </Typography>
        </legend>
        <TextField
          type="number"
          name="targetVolum"
          InputLabelProps={{
            shrink: true,
          }}
          className={style.textField}
          label={Vocabulary.targetVolum}
          fullWidth
          size="small"
          value={Object.assign(state)[trimester]?.targetVolum ?? ""}
          onChange={(event) => handleChangeTextFields(event, trimester)}
        />

        <TextField
          name="comisionProfit"
          InputLabelProps={{
            shrink: true,
          }}
          InputProps={{
            inputComponent: NumericFormatCustom,
          }}
          className={style.textField}
          label={Vocabulary.profitCommission}
          fullWidth
          size="small"
          value={Object.assign(state)[trimester]?.comisionProfit ?? ""}
          onChange={(event) => handleChangeTextFields(event, trimester)}
        />
        <TextField
          name="comisionCA"
          InputLabelProps={{
            shrink: true,
          }}
          InputProps={{
            inputComponent: NumericFormatCustom,
          }}
          className={style.textField}
          label={Vocabulary.CACommission}
          fullWidth
          size="small"
          value={Object.assign(state)[trimester]?.comisionCA ?? ""}
          onChange={(event) => handleChangeTextFields(event, trimester)}
        />
      </fieldset>
    );
  };

  /**
   * save settings for selected location
   * @returns
   */
  const updateSalarySettings = async () => {
    if (!activeLocations || activeLocations.length === 0) return;
    const selectedLocation = activeLocations[selectedTabIndex];
    if (!selectedLocation) return;
    const url = `${urlEnum.locationSettings}/${selectedLocation.id}/batch`;
    const purchaseTypeCommissions = Object.fromEntries(
      Object.entries(state.purchaseTypeCommissions).map(([id, rate]) => [
        id,
        rate ? convertFromPercentageToDecimal(rate) : "0",
      ]),
    );

    const dataToSave = {
      ...state,
      marketingCommission: state.marketingCommission
        ? convertFromPercentageToDecimal(state.marketingCommission)
        : "",
      managerCommission: state.managerCommission
        ? convertFromPercentageToDecimal(state.managerCommission)
        : "",
      managerCommissionForUnachievedTarget:
        state.managerCommissionForUnachievedTarget
          ? convertFromPercentageToDecimal(
              state.managerCommissionForUnachievedTarget,
            )
          : "",
      purchaseTypeCommissions,
    };
    const res = await updateData(url, dataToSave);
    if (!res) {
      return;
    }
  };

  return (
    <>
      <ToggleButtonGroup
        value={selectedTabIndex}
        exclusive
        onChange={(_, newValue) => {
          if (newValue !== null) setSelectedTabIndex(newValue);
        }}
        aria-label="location selector"
        fullWidth
        sx={{
          marginTop: 1,
          gap: 1.5,
          "& .MuiToggleButton-root": {
            border: "none",
            borderRadius: "8px",
            padding: "12px 24px",
            textTransform: "none",
            fontSize: "0.95rem",
            fontWeight: 500,
            backgroundColor: "#f5f5f5",
            color: "#666",
            transition: "all 0.2s ease",
            "&.Mui-selected": {
              backgroundColor: "#FF6633",
              color: "#fff",
              boxShadow: "0 2px 8px rgba(255, 102, 51, 0.3)",
              "&:hover": {
                backgroundColor: "#ff5722",
              },
            },
            "&:hover": {
              backgroundColor: "#ebebeb",
            },
          },
        }}
      >
        {activeLocations.map((location: any, index: number) => (
          <ToggleButton key={location.id} value={index}>
            {`${Vocabulary.location}: ${location.nume}`}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
      <Paper
        elevation={0}
        sx={{
          padding: 3,
          marginBottom: 4,
          borderRadius: 2,
          borderWidth: "0px 1px 1px 1px",
          borderStyle: "solid",
          borderColor: "#e0e0e0",
          backgroundColor: "#fff",
        }}
      >
        <ValidatorForm
          method="get"
          onSubmit={updateSalarySettings}
          id="settingsPlatform"
          style={{ marginTop: 10 }}
        >
          {/* Quarterly Targets Section */}
          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h6"
              sx={{
                mb: 2,
                fontWeight: 600,
                color: "#333",
                fontSize: "1.1rem",
              }}
            >
              {Vocabulary.Trimester}
            </Typography>
            <Divider sx={{ mb: 3 }} />
            <Grid container spacing={2}>
              {Object.keys(state).map((trimester: any, key: number) => {
                if (key <= 3)
                  return (
                    <Grid item xs={12} md={6} lg={3} key={key}>
                      {renderTrimester(trimester, key + 1)}
                    </Grid>
                  );
              })}
            </Grid>
          </Box>

          {/* Commission Settings Section */}
          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h6"
              sx={{
                mb: 2,
                fontWeight: 600,
                color: "#333",
                fontSize: "1.1rem",
              }}
            >
              Setări Comisioane
            </Typography>
            <Divider sx={{ mb: 3 }} />
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  type="number"
                  name="ComisionVanzare"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{ endAdornment: <>%</> }}
                  className={style.textField}
                  label={Vocabulary.comisionVanzare}
                  fullWidth
                  size="small"
                  value={state?.ComisionVanzare}
                  onChange={(event) => handleChangeTextFields(event)}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  type="number"
                  name="IDCostComisionAchizitie"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{ endAdornment: <>%</> }}
                  className={style.textField}
                  label={Vocabulary.comisionAchizitie}
                  fullWidth
                  size="small"
                  value={state?.IDCostComisionAchizitie}
                  onChange={(event) => handleChangeTextFields(event)}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  type="number"
                  name="IDCostComisionLogistica"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{ endAdornment: <>%</> }}
                  className={style.textField}
                  label={Vocabulary.comisionLogistica}
                  fullWidth
                  size="small"
                  value={state?.IDCostComisionLogistica}
                  onChange={(event) => handleChangeTextFields(event)}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  type="number"
                  name="ComisionTargetVolum"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{ endAdornment: <>%</> }}
                  className={style.textField}
                  label={Vocabulary.targetCommision}
                  fullWidth
                  size="small"
                  value={state.ComisionTargetVolum}
                  onChange={(event) => handleChangeTextFields(event)}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  type="number"
                  name="ComisionTargetCA"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{ endAdornment: <>%</> }}
                  className={style.textField}
                  label={Vocabulary.CACommission}
                  fullWidth
                  size="small"
                  value={state.ComisionTargetCA}
                  onChange={(event) => handleChangeTextFields(event)}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  type="number"
                  name="ComisionTargetProfit"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{ endAdornment: <>%</> }}
                  className={style.textField}
                  label={Vocabulary.profitCommission}
                  fullWidth
                  size="small"
                  value={state.ComisionTargetProfit}
                  onChange={(event) => handleChangeTextFields(event)}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  // type="number"
                  name="minimumCommission"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{ endAdornment: "Lei" }}
                  className={style.textField}
                  label={Vocabulary.minimumCommission}
                  fullWidth
                  size="small"
                  value={state.minimumCommission}
                  onChange={(event) => handleChangeTextFields(event)}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  type="number"
                  name="marketingCommission"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{ endAdornment: <>%</> }}
                  className={style.textField}
                  label={Vocabulary.marketingCommission}
                  fullWidth
                  size="small"
                  value={state.marketingCommission}
                  onChange={(event) => handleChangeTextFields(event)}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  type="number"
                  name="managerCommission"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{ endAdornment: <>%</> }}
                  className={style.textField}
                  label={Vocabulary.managerCommission}
                  fullWidth
                  size="small"
                  value={state.managerCommission}
                  onChange={(event) => handleChangeTextFields(event)}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  type="number"
                  name="managerCommissionForUnachievedTarget"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{ endAdornment: <>%</> }}
                  className={style.textField}
                  label={Vocabulary.managerCommissionForUnachievedTarget}
                  fullWidth
                  size="small"
                  value={state.managerCommissionForUnachievedTarget}
                  onChange={(event) => handleChangeTextFields(event)}
                />
              </Grid>
            </Grid>
          </Box>

          {/* Purchase Type Commissions Section */}
          {purchaseTypes.length > 0 && (
            <Box sx={{ mb: 4 }}>
              <Typography
                variant="h6"
                sx={{ mb: 2, fontWeight: 600, color: "#333", fontSize: "1.1rem" }}
              >
                {Vocabulary.purchaseTypeCommissionsSection}
              </Typography>
              <Divider sx={{ mb: 3 }} />
              <Grid container spacing={2}>
                {purchaseTypes.map((type) => (
                  <Grid item xs={12} sm={6} md={4} key={type.id}>
                    <TextField
                      type="number"
                      InputLabelProps={{ shrink: true }}
                      InputProps={{ endAdornment: <>%</> }}
                      className={style.textField}
                      label={type.nume}
                      fullWidth
                      size="small"
                      value={state.purchaseTypeCommissions[String(type.id)] ?? ""}
                      onChange={(e) =>
                        handleChangePurchaseTypeCommission(type.id, e.target.value)
                      }
                    />
                  </Grid>
                ))}
              </Grid>
            </Box>
          )}

          {/* Tax Settings Section */}
          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h6"
              sx={{
                mb: 2,
                fontWeight: 600,
                color: "#333",
                fontSize: "1.1rem",
              }}
            >
              Setări Taxe
            </Typography>
            <Divider sx={{ mb: 3 }} />
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  type="number"
                  name="taxForLeasingBonus"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{ endAdornment: <>%</> }}
                  className={style.textField}
                  label={Vocabulary.taxForLeasingBonus}
                  fullWidth
                  size="small"
                  value={state.taxForLeasingBonus}
                  onChange={(event) => handleChangeTextFields(event)}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  type="number"
                  name="generalTax"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{ endAdornment: <>%</> }}
                  className={style.textField}
                  label={Vocabulary.generalTax}
                  fullWidth
                  size="small"
                  value={state.generalTax}
                  onChange={(event) => handleChangeTextFields(event)}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  type="number"
                  name="socialInsurance"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{ endAdornment: <>%</> }}
                  className={style.textField}
                  label={Vocabulary.socialInsurance}
                  fullWidth
                  size="small"
                  value={state.socialInsurance}
                  onChange={(event) => handleChangeTextFields(event)}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  type="number"
                  name="healthInsurance"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{ endAdornment: <>%</> }}
                  className={style.textField}
                  label={Vocabulary.healthInsurance}
                  fullWidth
                  size="small"
                  value={state.healthInsurance}
                  onChange={(event) => handleChangeTextFields(event)}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  type="number"
                  name="incomeTax"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{ endAdornment: <>%</> }}
                  className={style.textField}
                  label={Vocabulary.incomeTax}
                  fullWidth
                  size="small"
                  value={state.incomeTax}
                  onChange={(event) => handleChangeTextFields(event)}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  type="number"
                  name="minimalSellingTarget"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{ endAdornment: <>%</> }}
                  className={style.textField}
                  label={Vocabulary.minimalSellingTarget}
                  fullWidth
                  size="small"
                  value={state.minimalSellingTarget}
                  onChange={(event) => handleChangeTextFields(event)}
                />
              </Grid>
            </Grid>
          </Box>
        </ValidatorForm>
      </Paper>
    </>
  );
}
